(() => {
  const videos = document.querySelectorAll(
    '.bbl-vhero__video, .bbl-provision__video, .bbl-film__video'
  );

  if (!videos.length || !('IntersectionObserver' in window)) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && !reduceMotion) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: [0, 0.35, 0.75] });

  videos.forEach((video) => observer.observe(video));
})();
